export const CHECK = "CHECK";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const BOOT_HASH = "BOOT_HASH";
export const HASH_ID = "HASH_ID";
export const FRESH = "FRESH";
export const REFRESH_TOKEN_LIFETIME = "REFRESH_TOKEN_LIFETIME";

export default {
    CHECK,
    LOGIN,
    LOGOUT,
    BOOT_HASH,
    HASH_ID,
    FRESH,
    REFRESH_TOKEN_LIFETIME
};
